import Bike from "./bike";

export default Bike;
